module.exports = __webpack_public_path__ + "static/img/UFSB-DKSZekpn.b1e978d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/UFSB-DKSZekpn.png
// module id = 0qvY
// module chunks = 16